class ProductVariantTitle extends HTMLElement {
  connectedCallback() {
    this.variantObserver?.disconnect();

    if (this.hasAttribute('data-suppressed')) return;

    this.valueElement = this.querySelector('[data-product-variant-title-value]');
    this.productDetails = this.closest('[data-product-details]');

    if (!this.productDetails) return;

    this.variantObserver = new MutationObserver(this.syncFromProductDetails);
    this.variantObserver.observe(this.productDetails, {
      attributes: true,
      attributeFilter: ['data-variant'],
    });
    this.syncFromProductDetails();
  }

  disconnectedCallback() {
    this.variantObserver?.disconnect();
    this.variantObserver = null;
  }

  syncFromProductDetails = () => {
    const variantData = [...this.productDetails.querySelectorAll('variant-picker[data-variant-picker]')]
      .find((picker) => picker.dataset.productId === this.dataset.productId)
      ?.querySelector('script[data-product-variants]');
    if (!variantData?.textContent) return;

    let variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch {
      return;
    }

    if (!Array.isArray(variants)) return;

    const selectedVariantId = this.productDetails.dataset.variant;
    const selectedVariant = variants.find((variant) => String(variant.id) === selectedVariantId);
    const value = selectedVariant?.variantSubtitle;
    const variantTitle = typeof value === 'string' ? value.trim() : '';

    if (this.valueElement instanceof HTMLElement) {
      this.valueElement.textContent = variantTitle;
    }
    this.hidden = variantTitle === '';
  };
}

if (!customElements.get('product-variant-title')) {
  customElements.define('product-variant-title', ProductVariantTitle);
}
